// alterar arquivo: public/index.html
// checar se existe código do google analytics (apagar ou substituir se for o caso)

// alterar arquivos: .firebaserc (conferir nesse se o default e target apontam para o projeto correto do firebase), firebase.json, package.json e info.txt com o nome do projeto no firebase

// color primary: public/assets/switcher/css/color2.css
// color secondary: public/assets/switcher/css/color2.css: 135

export const id_firebase = "qnwMwEmlNA8c2mNw7noj";  // Shopping 


export const ids_firebase = [
    "Aa5EYFJ72u0NxZBxFnMs", // Kar 7.2 Veículos 0
    "ucRU00ViZU39m9ak1hr5", // B8 Veículos 1
    "uL48rfBNcbr7fnbDoyET", // M&A 2
    "SP3u3VzRQmZjk56hOrWP", // Garage77 3
    "FHS8FDsZCvVvIgT07UHL", // Maverick 4
    "SBh9mDmFmLQDSifd3trq", // Dcar motors 5
    "oEjoQRpPsG9NhUTGhSeN", // Top Cristal 6
    "alamiMbGw4XoYJk1oTD3", // flex motors 7
    "oEjoQRpPsG9NhUTGhSeN", // top cristal / flap 8
    "RQcx1rNKNoeUUjBb7vmT"  // GRS Veículos 9
];

export const href_revenda = [
    "veiculo_kar",
    "veiculo_b8",
    "veiculo_mea",
    "veiculo_garage",
    "veiculo_maverick",
    "veiculo_dcar",
    "veiculo_topcristal",
    "veiculo_flex",
    "veiculo_flap",
    "veiculo_grs"
];
